import {
  AvatarProps,
  Brand,
  BrandProps,
} from "@patternfly/react-core";
import {
  PageHeader,
  PageHeaderProps,
  PageHeaderTools,
} from "@patternfly/react-core/deprecated";
import {
  label,
} from "@keycloak/keycloak-ui-shared";
import { ExternalLinkSquareAltIcon } from "@patternfly/react-icons";
import { TFunction } from "i18next";
import Keycloak, { type KeycloakTokenParsed } from "keycloak-js";

import { Button } from "@patternfly/react-core";
import { ReactNode } from "react";

import { AccountEnvironment, useEnvironment } from "@keycloak/keycloak-account-ui";
import { useTranslation } from "react-i18next";
import { environment } from "./environment";


const ReferrerLink = () => {
  const { t } = useTranslation();

  return environment.referrerUrl ? (
    <Button
      data-testid="referrer-link"
      component="a"
      href={environment.referrerUrl.replace("_hash_", "#")}
      variant="link"
      icon={<ExternalLinkSquareAltIcon />}
      iconPosition="right"
      isInline
    >
      {t("backTo", {
        app: label(t, environment.referrerName, environment.referrerUrl),
      })}
    </Button>
  ) : null;
};

function loggedInUserName(
  token: KeycloakTokenParsed | undefined,
  t: TFunction,
) {
  if (!token) {
    return t("unknownUser");
  }

  const givenName = token.given_name;
  const familyName = token.family_name;
  const preferredUsername = token.preferred_username;

  if (givenName && familyName) {
    return t("fullName", { givenName, familyName });
  }

  return givenName || familyName || preferredUsername || t("unknownUser");
}

type BrandLogo = BrandProps & {
  href: string;
};

type KeycloakMastheadProps = PageHeaderProps & {
  keycloak: Keycloak;
  brand: BrandLogo;
  avatar?: AvatarProps;
  features?: {
    hasLogout?: boolean;
    hasManageAccount?: boolean;
    hasUsername?: boolean;
  };
  kebabDropdownItems?: ReactNode[];
  dropdownItems?: ReactNode[];
  toolbarItems?: ReactNode[];
};

const KeycloakMasthead = ({
  keycloak,
  brand: { href: brandHref, ...brandProps },
  avatar,
  kebabDropdownItems,
  dropdownItems = [],
  toolbarItems,
  ...rest
}: KeycloakMastheadProps) => {
  const { environment } = useEnvironment<AccountEnvironment>();

  const { t } = useTranslation();



  return (
    <PageHeader
      {...rest}
      logo={<Brand {...brandProps} />}
      logoProps={{ href: brandHref }}
      headerTools={
        <PageHeaderTools>
          {environment.referrerUrl &&
            <div className="pf-c-page__header-tools-group">
              <ReferrerLink />
            </div>
          }

          <div className="pf-c-page__header-tools-group">
            <Button id="signOutButton" variant="secondary" onClick={() => keycloak.logout()}>{t("signOut")}</Button>
          </div>

          <span style={{ marginLeft: '10px' }} id="loggedInUser">{loggedInUserName(keycloak.idTokenParsed, t)}</span>
        </PageHeaderTools>
      }
    />
  );
};

export default KeycloakMasthead;
